/*eslint-disable */
import {
  bus
} from '../../main';
const $ = window.jQuery = require('jquery');  
import toast from '../../services/toast';
import lymphomap_form from '../../components/lymphomap-form/index.vue';
export default {
  name: 'lymphomap',
  components: {
    'lymphomap-form':lymphomap_form
  },
  props: [],
  data () {
    return {
    }
  },
  computed: {
  },
  mounted () {
  },
  methods: {
  },
  beforeCreate: function() {
  },
  beforeRouteLeave: function(to, from, next) {
    next();
  },
}


